// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"1b77e0ac","453":"acca0757","509":"9cfeba95","680":"e5e9ad64","834":"f679e6dc"}[chunkId] + ".chunk.js";
};